import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductionJobShared } from '@models/production-job-shared.model';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-shared-production-downloads',
    templateUrl: './shared-production-download-settings.component.html',
    styleUrl: './shared-production-download-settings.component.scss',
    standalone: false
})
export class SharedProductionDownloadSettingsComponent extends BaseComponent implements OnInit {

  public sharedLinkForm: FormGroup;
  public sharedJob: ProductionJobShared;
  public isProductionShared: boolean = false;
  public sharedProductionLoaded: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<SharedProductionDownloadSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) data,
        private fb: FormBuilder
  ) {
    super();
    this.isProductionShared = !!data?.sharedDetails?.sharedId;
    this.sharedLinkForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(256), Validators.pattern(/^[^\\/:*?<>|^]*$/)]],
      expirationDate: [null]
    });
    this.sharedJob = {
      sharedId: data?.sharedDetails?.sharedId || null,
      productionJobId: data?.sharedDetails?.productionJobId || '',
      downloadPassword: data?.sharedDetails?.downloadPassword || '',
      expires: data?.sharedDetails?.expires || ''
    };
    this.sharedProductionLoaded = true;
  }

  ngOnInit(): void {
    if (this.isProductionShared){
      this.setSharedJob(this.sharedJob);
    }
    else{
      this.sharedLinkForm.disable();
    }
  }

  public updateShared(): void {
    if (this.sharedLinkForm.invalid)
      return;
    
    this.sharedJob.downloadPassword = this.sharedLinkForm.get('password').getRawValue();
    this.sharedJob.expires = this.sharedLinkForm.get('expirationDate').getRawValue();
    this.dialogRef.close({
      isGenerateLink: true,
      sharedProductionJob: this.sharedJob
    });
  }

  public close(): void {
    this.dialogRef.close(null);
  }

  public toggleFormState(): void {
    if (this.isProductionShared) {
      this.sharedLinkForm.enable();
      this.sharedLinkForm.get('password')?.setValidators([
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(256),
        Validators.pattern(/^[^\\/:*?<>|^]*$/)
      ]);
      this.sharedLinkForm.get('expirationDate').setValue(new Date(Date.now() + 7 * 86400000));

    } 
    if (!this.isProductionShared) {
      
      this.sharedLinkForm.reset();
      this.sharedLinkForm.disable();
    }

    this.sharedLinkForm.get('password')?.updateValueAndValidity();
  }

  private setSharedJob(sharedJob: ProductionJobShared): void {
    this.sharedJob = sharedJob;
    this.sharedLinkForm.get('password').setValue(sharedJob.downloadPassword);
    this.sharedLinkForm.get('expirationDate').setValue(this.getDate(sharedJob.expires));
  }

  public removeSharedAccess() {
    this.dialogRef.close({
      isRemoveShare: true,
      sharedProductionJob: this.sharedJob
    });
  }

  private getDate(date: string): Date {
    if (!date) return null;
    return new Date(date);
  }

}
